import { render } from "./RoomDetailCanvas.vue?vue&type=template&id=37dab983"
import script from "./RoomDetailCanvas.vue?vue&type=script&lang=js"
export * from "./RoomDetailCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__